import { Component, h } from 'preact';
import linkState from 'linkstate';
import cx from 'classnames';
import findIndex from 'lodash-es/findIndex';

import { InquiryStage, InquiryStageCounts, InquiryStageDefinition } from 'types/inquiries';
import { INQUIRY_PAGE_STAGES } from '../../../../../constants/inquiries';
import { InquiryGridSearchInput } from '../search/inquiry-grid-search-input';

interface InquiryPageHeaderProps {
  stageName: string;
  stageCount: number;
  stageActive: boolean;

  searchInput?: string;
  searchCount?: number;

  onLeftStageClick?: (event: Event) => void;
  onRightStageClick?: (event: Event) => void;
  onSearch?: (search: string) => void;
  onFilterButtonClick?: () => void;

  cardCounts: InquiryStageCounts;
  sticky?: boolean;
  scrolled?: boolean;
}
interface InquiryPageHeaderState {
  searchText?: string;
}

export class InquiryPageHeader extends Component<InquiryPageHeaderProps, InquiryPageHeaderState> {
  onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.dataTransfer.dropEffect = 'move';
  }

  onDrop(evt: DragEvent, stage: InquiryStage) {
    console.log('Got data:', evt.dataTransfer.getData('text/plain'), stage);
  }

  onDesktopSearchClick() {
    if (this.props.onSearch) {
      this.props.onSearch(this.state.searchText);
    }
  }

  getDesktopStageRow(props: InquiryPageHeaderProps, state: InquiryPageHeaderState) {
    return INQUIRY_PAGE_STAGES.map(stageDefn => (
      <a href={ `/kumita-brokers/inquiries/${stageDefn.slug}` }
        className={ cx({ 'active': stageDefn.name == props.stageName && props.stageActive }) }
        onDragOver={ evt => this.onDragOver(evt) }
        onDrop={ evt => this.onDrop(evt, stageDefn.slug) }>
        <span>{ stageDefn.name }</span>
      </a>
    ));
  }

  getDesktopStageCountsRow(props: InquiryPageHeaderProps, state: InquiryPageHeaderState) {
    const { cardCounts } = props;

    return INQUIRY_PAGE_STAGES.map(stageDefn => (
      <span className="hi-inqpage-header__count-label"
        onDragOver={ evt => this.onDragOver(evt) }
        onDrop={ evt => this.onDrop(evt, stageDefn.slug) }
      >
        { cardCounts[stageDefn.slug] || 0 } { cardCounts[stageDefn.slug] == 1 ? 'card' : 'cards' }
      </span>
    ))
  }

  canMoveLeft(props: InquiryPageHeaderProps) {
    const index = findIndex(INQUIRY_PAGE_STAGES, { name: props.stageName });
    return index > 0;
  }

  canMoveRight(props: InquiryPageHeaderProps) {
    const index = findIndex(INQUIRY_PAGE_STAGES, { name: props.stageName });
    return index < INQUIRY_PAGE_STAGES.length - 1;
  }

  render(props: InquiryPageHeaderProps, state: InquiryPageHeaderState) {
    return (
      <div className={ cx('hi-inqpage-header', {
        'hi-inqpage-header--sticky': props.sticky,
        'hi-inqpage-header--scrolled': props.scrolled
      }) }>
        {/* MOBILE */}
        {/* Search/Filter controls */}
        <div className="hi-inqpage-header__filter-row">
          <a href='/kumita-brokers/inquiries/search' className="hi-inqpage-header__filter-control">
            <i className="fas fa-search" /> Search
          </a>
          <a href='#' className="hi-inqpage-header__filter-control" onClick={ () => props.onFilterButtonClick() }>
            <i className="fas fa-filter" /> Filter
          </a>
        </div>
        {/* Stage controls and drop areas */}
        <div className="hi-inqpage-header__stage-row">
          {/* PLACEHOLDER! */}
          <button className="hi-inqpage-header__stage-left"
            disabled={ !this.canMoveLeft(props) }
            onClick={ props.onLeftStageClick }>
          </button>

          <div className="hi-inqpage-header__stage-name-group">
            <span className="hi-inqpage-header__stage-name">
              { props.stageName }
            </span>
            <span className="hi-inqpage-header__stage-count">
              { props.stageCount } { props.stageCount == 1 ? 'card' : 'cards' }
            </span>
          </div>

          {/* PLACEHOLDER! */}
          <button className="hi-inqpage-header__stage-right"
            disabled={ !this.canMoveRight(props) }
            onClick={ props.onRightStageClick }>
          </button>
        </div>

        {/* DESKTOP */}
        {/* Search/Filter controls */}
        {/* Stage controls and drop areas */}

        <div className="hi-inqpage-header__filter-row--desktop">
          <InquiryGridSearchInput
            searchInput={ state.searchText }
            resultCount={ props.searchCount }
            onInput={ linkState(this, 'searchText') }
            onSubmit={ () => this.onDesktopSearchClick() } />
          <button className="btn btn-secondary"
            onClick={ () => this.onDesktopSearchClick() }
            disabled={ !state.searchText }
          >
            Search
          </button>
          <button className="btn btn-outline-dark" onClick={ props.onFilterButtonClick }>
            Set filter
          </button>
        </div>
        <div className="hi-inqpage-header__stage-row--desktop">
          { this.getDesktopStageRow(props, state) }
        </div>
        <div className="hi-inqpage-header__count-row--desktop">
          { this.getDesktopStageCountsRow(props, state) }
        </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps: InquiryPageHeaderProps) {
    this.setState({ searchText: nextProps.searchInput });
  }
}